import { Component } from '@angular/core';
import { EditVariantListComponent } from 'components/admin/product-variantlist/edit-variant-list.component';
import { CredentialType } from 'enums/CredentialType';
import { VariantListModel } from 'models/generated/Entities.GormCrm.VariantList';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { ProductService } from 'services/product.service';

@Component({
	selector: 'list-variant-lists',
	templateUrl: './list-variant-lists.component.html',
	imports: [Layout, ListView, TranslatePipe]
})
@ComponentUrl('list-variant-lists')
@CredentialRequired(CredentialType.ProductsAccessFull)
export class ListVariantListsComponent {

	variantLists?: VariantListModel[];
	productsAccessFullCredential = CredentialType.ProductsAccessFull;

	constructor(private readonly navigation: NavigationService, private readonly productService: ProductService) {
		this.productService.getAllVariantLists().then(variantLists => this.variantLists = variantLists);
	}

	createList() {
		this.navigation.openRelativeView(this, 'edit-variant-list', EditVariantListComponent);
	}

	editList(variantList: VariantListModel) {
		this.navigation.openRelativeView(this, 'edit-variant-list', EditVariantListComponent).then(view => view.variantListId = variantList.id!);
	}
}
